import { render, staticRenderFns } from "./NotificationsAddEditModal.vue?vue&type=template&id=26419b2b&"
import script from "./NotificationsAddEditModal.vue?vue&type=script&lang=js&"
export * from "./NotificationsAddEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports